import * as React from 'react';

interface IAmeyoPasswordProps {
  size?: string;
  strokeColor?: string;
}
const GenerateAmeyoPasswordIcon = (props: IAmeyoPasswordProps) => {
  const { size = 24, strokeColor = 'var(--bg-primary)' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2073_11984)">
        <path
          d="M15.222 14.2638C16.1105 14.7351 16.999 14.681 17.818 14.0629C19.116 13.0817 19.3864 11.266 18.4207 9.95252C17.818 9.14126 17.0299 8.69313 15.9714 8.86311C15.1834 8.99446 14.488 9.32669 13.8467 9.79027C12.9736 10.4238 12.1778 11.1424 11.382 11.8686C10.7562 12.4404 10.0917 12.9658 9.28821 13.2671C7.82794 13.8234 6.44494 12.7494 6.62265 11.1887C6.72309 10.3311 7.37982 9.75163 8.22971 9.75163C8.60057 9.75163 8.9328 9.85208 9.27276 9.98342C9.81476 10.2036 10.8147 10.7869 11.3139 11.085C11.3538 11.1088 11.3935 11.0568 11.3595 11.0251C10.8631 10.5622 9.74967 9.56047 9.01779 9.17989C8.07518 8.69313 7.13258 8.71631 6.25178 9.30351C5.27055 9.96797 4.92287 10.9415 5.01558 12.1081C5.13148 13.5839 6.669 14.7892 8.13699 14.5728C9.08733 14.4338 9.85223 13.9393 10.6094 13.4062C11.3666 12.873 12.0156 12.2163 12.7109 11.6059C13.2132 11.1655 13.7308 10.7406 14.3103 10.4161C14.882 10.0993 15.4924 9.88298 16.1491 10.0452C17.5476 10.4006 18.0266 12.1622 17.0299 13.2439C16.7363 13.5607 16.3964 13.7384 15.9483 13.7152C15.6469 13.6998 15.3688 13.6148 15.0984 13.5066C14.5185 13.2769 13.32 12.6121 12.7425 12.2857C12.7018 12.2627 12.663 12.3164 12.6983 12.347C13.2524 12.8272 14.4955 13.8743 15.2297 14.256L15.222 14.2638Z"
          fill="#FCFCFD"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.222 14.2638C16.1105 14.7351 16.999 14.681 17.818 14.0629C19.116 13.0817 19.3864 11.266 18.4207 9.95255C17.818 9.14129 17.0299 8.69317 15.9714 8.86314C15.1834 8.99449 14.488 9.32672 13.8467 9.7903C12.9736 10.4238 12.1778 11.1424 11.382 11.8687C10.7562 12.4404 10.0917 12.9658 9.28821 13.2671C7.82794 13.8234 6.44494 12.7495 6.62265 11.1888C6.72309 10.3311 7.37982 9.75166 8.22971 9.75166C8.60057 9.75166 8.9328 9.85211 9.27276 9.98345C9.81476 10.2036 10.8147 10.7869 11.3139 11.085C11.3538 11.1088 11.3935 11.0568 11.3595 11.0252C10.8631 10.5623 9.74967 9.5605 9.01779 9.17992C8.07518 8.69317 7.13258 8.71634 6.25178 9.30354C5.27055 9.968 4.92287 10.9415 5.01558 12.1082C5.13148 13.5839 6.669 14.7892 8.13699 14.5729C9.08733 14.4338 9.85223 13.9393 10.6094 13.4062C11.3666 12.8731 12.0156 12.2163 12.7109 11.606C13.2132 11.1656 13.7308 10.7406 14.3103 10.4161C14.882 10.0993 15.4924 9.88301 16.1491 10.0453C17.5476 10.4007 18.0266 12.1623 17.0299 13.2439C16.7363 13.5607 16.3964 13.7384 15.9483 13.7152C15.6469 13.6998 15.3688 13.6148 15.0984 13.5066C14.5185 13.277 13.32 12.6122 12.7425 12.2857C12.7018 12.2627 12.663 12.3164 12.6983 12.347C13.2524 12.8273 14.4955 13.8743 15.2297 14.2561L15.222 14.2638Z"
        fill={strokeColor}
        stroke={strokeColor}
        strokeWidth="0.25"
      />
      <defs>
        <clipPath id="clip0_2073_11984">
          <rect width="14" height="5.77152" fill="white" transform="translate(5 8.82449)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default GenerateAmeyoPasswordIcon;
